<template>
<!-- delimiter-icon="$vuetify.icons.delimiter"  -->
   <div class="container">
          <v-carousel
            max
            :cycle="set_false"
            height="550px"
            hide-delimiters
            prev-icon=" "
            :next-icon="next_arrow"
            dark
          >
            <v-carousel-item
              style="background: #4054B2; opacity: 50%"
              v-for="(card,i) in guide_cards"
              :key="i"
            >
            <div style="text-align: center;">
              <img style="width: 100px; padding-top: 20px" :src="card.src"/>
              <p style="width: auto; color: white; font-size: 25px; margin: auto, 0; text-align: center; padding: 15px"
                 class="mb-0 mt-4 ml-0 py-2">{{ card.headline }}</p> 
              <p style="width: auto; color: white; font-size: 18px; margin: auto, 0; text-align: center; padding: 50px"
                 class="mb-0 mt-2 ml-0 py-0">{{ card.text }}</p>
              <v-btn class="mb-2 mt-3 ml-0 py-0"
                     label=""
                     style="line-height: 1.3; font-size: 20px; background: white; width: 230px; height: 80px;"
                     color="indigo light" flat v-if="(i === 5)"
                     v-on:click="$emit('go')">I'm ready for my<br>Royal Experience!
              </v-btn>
            </div>
            </v-carousel-item>
          </v-carousel>
  </div>
</template>
<script>
export default {
  name: 'guide',
  data: () => ({
    next_arrow: '$vuetify.icons.next',
    set_false: false,
    guide_cards: [
          { 
            headline:`Welcome to Royal Experience!`,
            text: `Before you get started,
                   Let Us explain how this works..`,
            src: require('../assets/icon_re_white.png'),
            next: '$vuetify.icons.next'
          },
          {
            headline:`Anything is Possible!`,
            text:`With RE, you can create Virtually ANY
                  experience you can think of. From an 
                  all-inclusive chauffeured night out on 
                  the town to a wedding, to a family vacation,
                  or even a Champaign bubble bath. You can
                  really create ANYTHING!`,
            src: require('../assets/icon_test_01.png'),
            next: '$vuetify.icons.next'
          },
          {
            headline:`Let's Do This!`,
            text:`First, choose your experience start and end
                  dates. After which, you decide which high 
                  quality service you want from our Experience
                  Packages or to create your own custom Experience!`,
            src: require('../assets/icon_test_01.png'),
            next: '$vuetify.icons.next'
          },
          {
            headline:`The Numbers`,
            text:`Then, we send you a price estimate*, Now your Royal
                  Experience is booked!`,
            src: require('../assets/icon_test_01.png'),
            next: '$vuetify.icons.next'
          },
          {
            headline:`Safe and Sound`,
            text:`The best part is that all your personal information
                  and orders are kept confidential, encrypted and they
                  are NEVER shared. You also can track your order
                  progress and even chat with your personal Experience
                  Coordinator!`,
            src: require('../assets/icon_test_01.png'),
            next: '$vuetify.icons.next'
          },
          {
            headline:`Time to Relax!`,
            text:`No more time-consuming phone calls. No more endless
                  searching on the internet. No worries and no more
                  stress! Just relax while we get ready for you to
                  live your best life!`,
            src: require('../assets/icon_test_01.png'),
            next: ' '
          },
          ]
  }) 
}
</script>
 